import { ShowIf } from '@apply/components';
import { ExactDateSold } from './components/ExactDateSold';
import { YearSold } from './components/YearSold';
import { DateOrYearToggle } from './components/DateOrYearToggle';
import { useExperienceDateSoldTypeId } from '../../../../../fields/ExperienceFields';
import { ExperienceDateType } from '@apply/constants';

interface DateSoldProps {
    experienceId: string | undefined;
    required?: boolean;
}

export const DateSold: React.FC<DateSoldProps> = ({ experienceId, required = false }) => {
    const [dateSoldTypeId] = useExperienceDateSoldTypeId(experienceId);
    const effectiveType = dateSoldTypeId ?? ExperienceDateType.Exact;
    return (
        <>
            <>
                <br />
                <DateOrYearToggle
                    experienceId={experienceId}
                    required={required}
                />
                <ShowIf showIf={effectiveType == ExperienceDateType.Exact}>
                    <ExactDateSold
                        experienceId={experienceId}
                        required={required}
                    />
                </ShowIf>
                <ShowIf showIf={effectiveType == ExperienceDateType.YearOnly}>
                    <YearSold
                        experienceId={experienceId}
                        required={required}
                    />
                </ShowIf>
            </>
        </>
    );
};
